export const scrollToAnchor = (anchor: string, position?: ScrollLogicalPosition) => {
  const element = document.getElementById(anchor);
  element?.scrollIntoView({
    behavior: 'smooth',
    block: position ?? 'start',
    inline: 'nearest',
  });
};
